
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-re-edit-blog",
      function () {
        return require("private-next-pages/the-re-edit-blog.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-re-edit-blog"])
      });
    }
  